import { useState, useMemo, useRef, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import apiServices from '../../../services/service';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchDataAndUpdateStore,
  fetchInvoiceSalesOrderedItemAndAppendToModule,
  singleRowAddUpdateInStore,
} from '../../../redux/actions';
import { initValueInvoice } from '../../../shared/initials';
import InvoiceForm from './invoiceForm';
import {
  getGenericMasterFilteredListByKey,
  getGridDataByModuleKey,
  getInvoice,
  getInvoiceById,
  getProductList,
  getUser,
} from '../../../redux/selector';
import { validationSchemaInvoice } from './validationSchemaInvoice';
import Loader from '../../../shared/component/Loader';

const CL_ICONS = {
  chevL: <path d="M15 18l-6-6 6-6" />,
  check: <path d="M20 6 9 17l-5-5" />,
};
const CLIc = ({ name, size = 16, style }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" style={style}>
    {CL_ICONS[name] || null}
  </svg>
);

export const AddInvoice = () => {
  const userInfo = useSelector(getUser);
    // Update owner in initValueLead if it is an empty string
    if (!initValueInvoice.owner) {
      initValueInvoice.owner = userInfo?.user?.display_name;
      initValueInvoice.ownerId = userInfo?.user?.userId;
    }

  const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
  const [formData, setFormData] = useState(initValueInvoice);
  const [errormsg, setErrorMsg] = useState({});
  const [formEdited, setFormEdited] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState({});
  const navigate = useNavigate();
  const [imagefile, setImageFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get('id');
  const gridData = useSelector(getGridDataByModuleKey('invoice'));
  const invoiceList = useSelector(getInvoice);
  const [accountId, setAccountId] = useState('');
  const [quoteList, setQuoteList] = useState([]);
  const [salesOwnerList, setsalesOwnerList] = useState([]);
  
  const productList = useSelector(getProductList);
  const uomList = useSelector(getGenericMasterFilteredListByKey('UOM'));
  
  const handleUploadImage = async (imagefile) => {
    setImageFile(imagefile);
    setFormEdited(true);
  };

  const invoiceLocalData = useSelector((state) => {
    const invoiceId = location.state?.id || id;
    return getInvoiceById(state, invoiceId);
  });

  useEffect(() => {
    const fetchData = async () => {
      const invoiceId = location.state?.id || id;
      const invoiceDetails = formData?.invoiceDetails;
      const stateData = location.state;
      let updatedFormData = {
        ...formData,
        type: location.pathname.includes('Add') ? 'add' : 'edit',
      };

      if (location.pathname.includes('editInvoice')) {
        setLoading(true);
        try {
          const response = await apiServices.getInvoiceSalesOrderDetails(location.state);
          if (response.status === 200) {
            setLoading(false);
            const invoiceDetails = response.data?.invoiceDetails || [];

            updatedFormData = {
              ...location.state,
              invoiceDetails,
              type: 'edit',
            };

            setAccountId(invoiceLocalData?.accountId);
            getQuoteByAccountId(invoiceLocalData?.accountId);
            getSalesOwnerByQuoteAndAccountId(invoiceLocalData?.quoteId);
            setFormData({
              ...updatedFormData,
              type: 'edit',
              rowIndex: location.state?.rowIndex,
            });
          } else {
            setLoading(false);
            console.error('Failed to fetch invoice details:', response);
          }
        } catch (error) {
          setLoading(false);
          console.error('API error:', error);
        }
      }

      if (location.pathname.includes('createInvoice')) {
        let formDataValue = location.state != null ? location.state : formData;
        let currentDate = new Date();
        setFormData({
          ...formDataValue,
          invoiceDetails: formDataValue.saleOrderDetails || formDataValue.invoiceDetails,
          type: 'add',
          // invoiceOwner:
          //   location.state != null ? location.state?.salesOwner : userInfo?.user?.display_name,
          // invoiceOwnerId:
          //   location.state != null ? location.state?.salesOwnerId : userInfo?.user?.userId,
          invoiceDate: currentDate.toISOString().split('T')[0],
          callBy: location.state?.data != null ? location.state?.type : '',
        });
      }

      // if (invoiceList && invoiceList.length > 0 && invoiceId) {
      //   dispatch(
      //     fetchInvoiceSalesOrderedItemAndAppendToModule({
      //       moduleName: 'Invoice',
      //       id: id,
      //     })
      //   );
      // }
    };

    fetchData();
  }, [location, invoiceLocalData?.id]);

  console.log('🚀 ~ AddInvoice ~ invoiceLocalData:', invoiceLocalData);
  console.log(formData);

  const calculateQuoteTotals = (invoiceItem, adjustment = 0) => {
    const updatedWithCalcs = invoiceItem.map((item, index) => {
      const quantity = Number(item.quantity) || 0;
      const listPrice = Number(item.listPrice) || 0;
      const amount = quantity * listPrice;

      let discountPercent = Number(item.discountPercent) || 0;
      let discountAmount = Number(item.discountAmount) || 0;
      if (discountAmount && !discountPercent) {
        discountPercent = (discountAmount / amount) * 100;
      } else {
        discountAmount = (amount * discountPercent) / 100;
      }

      let taxPercent = Number(item.taxPercent) || 0;
      let taxAmount = Number(item.taxAmount) || 0;
      if (taxAmount && !taxPercent) {
        taxPercent = (taxAmount / amount) * 100;
      } else {
        taxAmount = (amount * taxPercent) / 100;
      }

      const lineTotal = amount - discountAmount + taxAmount;

      return {
        ...item,
        quantity,
        listPrice,
        amount,
        discountPercent,
        discountAmount,
        taxPercent,
        taxAmount,
        lineTotal,
        lineNumber: index + 1,
      };
    });

    const subTotal = updatedWithCalcs.reduce((sum, item) => sum + (item.amount || 0), 0);
    const discountTotal = updatedWithCalcs.reduce(
      (sum, item) => sum + (item.discountAmount || 0),
      0
    );
    const taxTotal = updatedWithCalcs.reduce((sum, item) => sum + (item.taxAmount || 0), 0);
    const grandTotal = subTotal - discountTotal + taxTotal + Number(adjustment || 0);

    return {
      invoiceDetails: updatedWithCalcs,
      subTotal,
      discountTotal,
      taxTotal,
      grandTotal,
    };
  };

  // GrowthOS re-skin fix: guard the row-update block so it only runs for line-item
  // patches (changeFrom === 'InvoiceSalesOrder'). Previously it ran for every field
  // change with rowIndex undefined, mutating invoiceDetails[undefined]; it only
  // "worked" because calculateQuoteTotals' .map skips the non-index prop. Now scalar
  // changes update the field (and recompute totals when Adjustment changes), matching
  // the Sales/Quote containers.
  const handleChangeForm = (e, rowIndex, changeFrom) => {
    if (changeFrom !== 'InvoiceSalesOrder') {
      const { name, value } = e.target;
      setFormData((prev) => {
        const updated = {
          ...prev,
          [name]: name === 'adjustment' ? parseFloat(value) || 0 : value,
        };
        if (name === 'adjustment') {
          const totals = calculateQuoteTotals(prev.invoiceDetails || [], updated.adjustment);
          return { ...updated, ...totals };
        }
        return updated;
      });
      setFormEdited(true);
      return;
    }

    setFormData((prev) => {
      const updatedItems = [...prev.invoiceDetails];
      const updatedRow = { ...updatedItems[rowIndex], ...e };
      updatedItems[rowIndex] = updatedRow;

      const totals = calculateQuoteTotals(updatedItems, prev.adjustment);

      return {
        ...prev,
        ...totals,
      };
    });
    setFormEdited(true);
  };

  const handleChange = (selectedOption, name, rowIndex = null) => {
    setSelectedOptions((prevState) => ({
      ...prevState,
      [name]: selectedOption,
    }));

    handleLookupDropDownChange(selectedOption.value, selectedOption, name, rowIndex);
  };

  // const handleLookupDropDownChange = (selectedId, selectedOption, name) => {
  //   const selectedValue = selectedOption.label;
  //   // Clear error for the current field
  //   setErrorMsg((prevErrorMsg) => ({
  //     ...prevErrorMsg,
  //     [name]: undefined,
  //   }));

  //   if (name == 'accountName') {
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       quoteName: '',
  //       quoteId: '',
  //       salesOrderId: null,
  //       salesOrder: null,
  //     }));
  //     setAccountId(selectedId);
  //     getQuoteByAccountId(selectedId);
  //   }
  //   if (name == 'quoteName') {
  //     getSalesOwnerByQuoteAndAccountId(selectedId);
  //   }

  //   const updatedFields = {
  //     contactName: { contactId: selectedId, contactName: selectedValue },
  //     salesOrder: { salesOrderId: selectedId, salesOrder: selectedValue },
  //     accountName: { accountId: selectedId, accountName: selectedValue },
  //     dealName: { opportunityId: selectedId, dealName: selectedValue },
  //     status: { status: selectedValue, statusId: selectedId },
  //     currencyPrice: { currencyId: selectedId, currencyPrice: selectedValue },
  //     quoteName: { quoteId: selectedId, quoteName: selectedValue },
  //     invoiceOwner: { invoiceOwnerId: selectedId, invoiceOwner: selectedValue },
  //   };

  //   if (updatedFields[name]) {
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       ...updatedFields[name],
  //     }));
  //     setFormEdited(true);
  //   }
  // };

  const handleLookupDropDownChange = (selectedId, selectedOption, name, rowIndex = null) => {
    const selectedValue = selectedOption.label;

    // Clear error for the current field
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));

    // Handle special side-effects
    if (name === 'accountName') {
      setFormData((prevData) => ({
        ...prevData,
        quoteName: '',
        quoteId: '',
        salesOrderId: null,
        salesOrder: null,
      }));
      setAccountId(selectedId);
      getQuoteByAccountId(selectedId);
    }

    if (name === 'quoteName') {
      getSalesOwnerByQuoteAndAccountId(selectedId);
    }

    const updatedFields = {
      contactName: (prev) => ({
        ...prev,
        contactId: selectedId,
        contactName: selectedValue,
      }),
      salesOrder: (prev) => ({
        ...prev,
        salesOrderId: selectedId,
        salesOrder: selectedValue,
      }),
      accountName: (prev) => ({
        ...prev,
        accountId: selectedId,
        accountName: selectedValue,
      }),
      dealName: (prev) => ({
        ...prev,
        opportunityId: selectedId,
        dealName: selectedValue,
      }),
      status: (prev) => ({
        ...prev,
        status: selectedValue,
        statusId: selectedId,
      }),
      currencyPrice: (prev) => ({
        ...prev,
        currencyId: selectedId,
        currencyPrice: selectedValue,
      }),
      quoteName: (prev) => ({
        ...prev,
        quoteId: selectedId,
        quoteName: selectedValue,
      }),
      invoiceOwnerId: (prev) => ({
        ...prev,
        invoiceOwnerId: selectedId,
        invoiceOwner: selectedValue,
      }),
      productId: (prev) => {
        const selectedProduct = productList.find((p) => p.id === selectedId);
        const updatedQuoteItems = [...(prev.invoiceDetails || [])];
        const currentRow = updatedQuoteItems[rowIndex] || {};

        updatedQuoteItems[rowIndex] = {
          ...currentRow,
          productId: selectedId,
          productName: selectedValue,
          listPrice: selectedProduct?.unitPrice || 0,
        };

        return {
          ...prev,
          invoiceDetails: updatedQuoteItems,
        };
      },
      uomId: (prev) => {
        const updatedQuoteItems = [...(prev.invoiceDetails || [])];
        const currentRow = updatedQuoteItems[rowIndex] || {};

        updatedQuoteItems[rowIndex] = {
          ...currentRow,
          uomId: selectedId,
          uom: selectedValue,
        };

        return {
          ...prev,
          invoiceDetails: updatedQuoteItems,
        };
      },
    };

    if (updatedFields[name]) {
      setFormData((prevData) => updatedFields[name](prevData));
      setFormEdited(true);
    }
  };

  const refs = {
    overview: useRef(null),
    salesOrder: useRef(null),
    attachments: useRef(null),
    emails: useRef(null),
    timeline: useRef(null),
  };

  const updateList = async (msg, id) => {
    setLoading(false);
    toast.success(msg, { position: 'top-right' });

    try {
      // Dispatch to update the store
      dispatch(
        singleRowAddUpdateInStore({
          moduleName: 'Invoice',
          moduleKey: 'invoice',
          id: formData.type === 'add' ? id : formData.id,
          rowIndex: formData.rowIndex,
        })
      );

      // Navigate based on the context
      if (formData.from === 'view') {
        navigate(`/sales/viewInvoice?id=${formData.id}`);
      } else {
        navigate('/sales/invoice');
      }
    } catch (error) {
      console.error('Failed to update invoice list:', error);
      toast.error('Something went wrong while updating the list.', {
        position: 'top-right',
      });
    }
  };

  // ✅ Function to handle checkbox toggle
const handleSameAsBillingChange = (e) => {
  const checked = e.target.checked;

  setFormData((prev) => ({
    ...prev,
    sameAsBilling: checked,
    ...(checked
      ? {
          shippingStreet: prev.billingStreet || "",
          shippingCity: prev.billingCity || "",
          shippingState: prev.billingState || "",
          shippingCountry: prev.billingCountry || "",
          shippingCode: prev.billingCode || "",
        }
      : {
          shippingStreet: "",
          shippingCity: "",
          shippingState: "",
          shippingCountry: "",
          shippingCode: "",
        }),
  }));
};

  const handleAddPriceSheetToItems = (selectedProducts) => {
    setFormData((prev) => {
      const updatedQuoteItems = (prev.invoiceDetails || []).map((item) => {
        const matchedProduct = selectedProducts.find((p) => p.productId === item.productId);

        if (matchedProduct) {
          return {
            ...item,
            listPrice: matchedProduct.listPrice,
          };
        }

        return item;
      });

      const totals = calculateQuoteTotals(updatedQuoteItems, prev.adjustment);

      return {
        ...prev,
        invoiceDetails: updatedQuoteItems,
        ...totals,
      };
    });

    setLoading(false);
  };

  const handleSubmit = async (formData) => {
    setLoading(true);
    try {
      const sanitizedData = {
        ...formData,
      };
      await validationSchemaInvoice.validate(sanitizedData, {
        abortEarly: false,
      });
      handleFormSubmit(sanitizedData);
    } catch (error) {
      setLoading(false);
      const fieldErrors = {};
      error.inner.forEach((err) => {
        fieldErrors[err.path] = err.message;
      });
      setErrorMsg(fieldErrors);
      const errorFields = Object.keys(fieldErrors);
      console.log('text', errorFields);
      if (errorFields.length > 0) {
        const firstErrorKey = errorFields[0];
        const errorRef = refs[firstErrorKey];
        console.log('errorRef', errorRef);
        if (errorRef?.current) {
          errorRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
          errorRef.current.focus();
        }
      } else {
        // Submit the form!
      }

      console.error('Validation Error:', fieldErrors);
    }
  };

  const handleCloseAddForm = () => {
    // if (formData.from === 'view' && formData.callBy == '') {
    //   navigate(`/sales/viewInvoice?id=${formData.id}&pageNo=${gridData?.inputPayload?.pageNumber}`);
    // } else if (formData.from === 'view' && formData.callBy == 'SalesView') {
    //   navigate(`/sales/viewSalesOrder?id=${formData.id}`);
    // } else if (formData.from === 'view' && formData.callBy == 'QuoteView') {
    //   navigate(`/quoteAI/regularQuoteView?id=${formData.id}`);
    // } else {
    //   navigate('/sales/invoice');
    // }
     navigate(-1);
  };

  const handleFormSubmit = async (formData) => {
    if (formData.type === 'add') {
      apiServices
        .createInvoice(formData)
        .then((response) => {
          if (response.status === 200) {
            const id = response.data;
            updateList('Invoice created successfully!', id);
          } else {
            setLoading(false);
            const errorMessages = [];
            for (const key in response.errors) {
              if (response.errors.hasOwnProperty(key)) {
                const messages = response.errors[key];
                errorMessages.push(...messages);
              }
            }
            errorMessages.forEach((errorMessage) => {
              toast.error(errorMessage, { position: 'top-right' });
            });
          }
        })
        .catch((error) => {
          console.error('Error:', error, 'DataFormat:', formData);
          toast.error('An unexpected error occurred.', {
            position: 'top-right',
          });
          setLoading(false);
        });
    } else {
      try {
        const { invoiceDetails, ...invoiceOnlyData } = formData;
        const invoiceResponse = await apiServices.updateInvoice(invoiceOnlyData);
        if (invoiceResponse.status === 200) {
          const quoteItemsPayload = {
            invoiceDetailList: invoiceDetails || [],
          };
          const itemUpdateRes = await apiServices.updateMultipleInvoiceDetails(quoteItemsPayload);

          if (itemUpdateRes.status === 200) {
            updateList('Invoice updated successfully!');
          } else {
            toast.error('Invoice details update failed.', {
              position: 'top-right',
            });
          }
        } else {
          setLoading(false);
          const errorMessages = [];
          for (const key in invoiceResponse.errors) {
            if (invoiceResponse.errors.hasOwnProperty(key)) {
              const messages = invoiceResponse.errors[key];
              errorMessages.push(...messages);
            }
          }
          errorMessages.forEach((errorMessage) => {
            toast.error(errorMessage, { position: 'top-right' });
          });
        }
      } catch (error) {
        console.error('Error:', error, 'DataFormat:', formData);
        toast.error('An unexpected error occurred.', {
          position: 'top-right',
        });
        setLoading(false);
      }
    }
  };

  const handleAddRow = () => {
    setFormData((prev) => ({
      ...prev,
      invoiceDetails: [
        ...(prev.invoiceDetails || []),
        {
          id: '',
          invoiceId: formData?.id,
          lineNo: 0,
          productId: '',
          priceSheetId: '',
          description: '',
          discountAmount: 0,
          taxPercent: 0,
          taxAmount: 0,
          lineTotal: 0,
          remarks: '',
        },
      ],
    }));
  };

  const handleDeleteRow = (index, id) => {
    getInvoiceSalesOrderDetailsDelete(id, index);
  };

const getInvoiceSalesOrderDetailsDelete = (id, index) => {
  if (id) {
    // Call API if id is present
    const data = { id: [id] };

    apiServices
      .getInvoiceSalesOrderDetailsDeleteById(data)
      .then((response) => {
        if (response.status === 200) {
          deleteRow(index);
        } else {
          setLoading(false);
        }
      })
      .catch((error) => {
        toast.error('An unexpected error occurred.', {
          position: 'top-right',
        });
        setLoading(false);
      });
  } else {
    // No ID, just delete the row locally
    deleteRow(index);
  }
};

// Reusable function to remove a row and re-index lineNumbers
const deleteRow = (index) => {
  setFormData((prev) => {
    if (prev.invoiceDetails.length <= 1) {
      toast.warn('At least one row is required.', {
        position: 'top-right',
      });
      return prev; // Prevent deleting the last row
    }

    const updatedItems = prev.invoiceDetails.filter((_, i) => i !== index);
    return {
      ...prev,
      invoiceDetails: updatedItems.map((item, idx) => ({
        ...item,
        lineNumber: idx + 1,
      })),
    };
  });
};


  const getQuoteByAccountId = (data) => {
    apiServices
      .getQuoteByAccountId(data)
      .then((response) => {
        if (response.status === 200) {
          setQuoteList(response?.data?.quote);
        }
      })
      .catch((error) => {
        toast.error('An unexpected error occurred.', {
          position: 'top-right',
        });
      });
  };

  const getSalesOwnerByQuoteAndAccountId = (data) => {
    if (data) {
      let apiReq = {
        quoteId: data,
        accountId: accountId,
      };
      apiServices
        .getSalesOwnerByQuoteAndAccountId(apiReq)
        .then((response) => {
          if (response.status === 200) {
            setsalesOwnerList(response?.data?.saleOrders);
          }
        })
        .catch((error) => {
          toast.error('An unexpected error occurred.', {
            position: 'top-right',
          });
        });
    }
  };

  const isEdit = formData.type === 'edit';
  const canSave = !!(formData?.subject && String(formData.subject).trim()) && !!formData?.accountId;

  return (
    <div className="gos-cl gos-quoteform">
      {loading && <Loader />}
      {/* sticky header */}
      <div className="gos-cl-header">
        <button type="button" className="gos-cl-back" onClick={handleCloseAddForm} title="Back to Invoices">
          <CLIc name="chevL" size={18} />
        </button>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div className="gos-cl-htitle">{isEdit ? 'Edit Invoice' : 'Create Invoice'}</div>
          <div className="gos-cl-hsub">
            Fields marked <span className="gos-cl-reqdot">*</span> are required
          </div>
        </div>
        <button type="button" className="gos-btn gos-btn-ghost" onClick={handleCloseAddForm}>Cancel</button>
        <button
          type="button"
          className="gos-btn gos-btn-primary"
          onClick={() => handleSubmit(formData)}
          disabled={loading || (isEdit && !formEdited) || !canSave}
          style={{ opacity: canSave && !(isEdit && !formEdited) ? 1 : 0.55 }}
        >
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Saving…
            </>
          ) : (
            <>
              <CLIc name="check" size={16} /> Save Invoice
            </>
          )}
        </button>
      </div>

      <div className="gos-cl-scroll">
        <InvoiceForm
          handleChangeForm={handleChangeForm}
          handleChange={handleChange}
          formData={formData}
          handleSubmit={handleSubmit}
          errormsg={errormsg}
          handleAddRow={handleAddRow}
          handleDeleteRow={handleDeleteRow}
          quoteList={quoteList}
          salesOrderList={salesOwnerList}
          handleAddPriceSheetToItems={handleAddPriceSheetToItems}
          handleSameAsBillingChange={handleSameAsBillingChange}
        />
      </div>
    </div>
  );
};

export default AddInvoice;
